import { useAppPersistenceStore } from '@ninjacart/nc-nk-store';
import { useRef, useState } from 'react';
// import { useAppPersistenceModerationStore } from '@ninjacart/nc-nk-moderation';
import { INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType, useEventZStore } from '@ninjacart/nc-nk-store';

export const useLanguageChange = () => {
  const [languageChangeBottomSheet, setLanguageChangeBottomSheet] = useState(false);
  const setAppLanguage = useAppPersistenceStore((state) => state.setAppLanguage);
  /**
   * To set value in another package store
   * use domain events emitter
   */
  // const setModerationAppLanguage = useAppPersistenceModerationStore(
  //   (state) => state.setModerationAppLanguage
  // );
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const onLanguageChange = (changedLang: string) => {
    if (changedLang) {
      setAppLanguage(changedLang);
      // setModerationAppLanguage(changedLang);
    }
  };

  const languageChange = () => {
    setLanguageChangeBottomSheet(true);
    const languageChangeClickEvent: INinjaEvent = {
      name: KissanEventType.LANGUAGE_CHANGE_CLICK,
      screenDetails: { screen: 'home header page' },
    };
    enqueue(languageChangeClickEvent);
  };

  return {
    languageChangeBottomSheet,
    setLanguageChangeBottomSheet,
    onLanguageChange,
    languageChange
  };
}; 